export const GetStrTotal = (label, total) => {
    let string = '';
    if (label) {
        if (total > 1 & !label.match(/univers/)) {
            string = `${label}s`;
        } else if (total === 0) {
            string = `${label}`;
        } else {
            string = `${label}`;
        }
    }
    return string;
}